import { showNotices } from "../repositories/NoticesRepository";
import { createRequestResourceCache } from "../utils/requestResourceCache";

// Ventana corta: evita el segundo GET provocado por el doble montaje de
// React.StrictMode sin mantener las alertas obsoletas durante varios minutos.
const noticesCache = createRequestResourceCache({ ttlMs: 3000 });

// Mostrar noticias
export const showNoticesService = async (date, options = {}) => {
  const key = `nomad-alerts:${String(date ?? "current")}`;

  return noticesCache.read(
    key,
    () => showNotices(date),
    { force: options.forceRefresh === true },
  );
};

export const invalidateNoticesCache = () => {
  noticesCache.clear();
};
